<template>
  <svg
    class="h-5 w-5 shrink-0"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g v-if="mateType === AssemblyMateType.Coincident">
      <line x1="5" y1="18" x2="18" y2="5" />
      <line x1="5" y1="5" x2="18" y2="18" opacity="0.45" />
      <circle cx="11.5" cy="11.5" r="2.2" fill="currentColor" stroke="none" />
    </g>
    <g v-else-if="mateType === AssemblyMateType.Parallel">
      <line x1="6" y1="6" x2="18" y2="18" />
      <line x1="3" y1="10" x2="15" y2="22" />
      <line x1="10" y1="3" x2="22" y2="15" />
    </g>
    <g v-else-if="mateType === AssemblyMateType.Perpendicular">
      <line x1="5" y1="19" x2="19" y2="19" />
      <line x1="12" y1="5" x2="12" y2="19" />
      <path d="M12 15h4v4" />
    </g>
    <g v-else-if="mateType === AssemblyMateType.Tangent">
      <circle cx="9" cy="14" r="5" />
      <line x1="14" y1="5" x2="21" y2="12" />
      <circle cx="14" cy="10" r="1.4" fill="currentColor" stroke="none" />
    </g>
    <g v-else-if="mateType === AssemblyMateType.Concentric">
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none" />
    </g>
    <g v-else-if="mateType === AssemblyMateType.Lock">
      <rect x="5" y="10" width="14" height="10" rx="1.5" />
      <path d="M8 10V8a4 4 0 0 1 8 0v2" />
      <line x1="12" y1="14" x2="12" y2="17" />
    </g>
    <g v-else-if="mateType === AssemblyMateType.Distance">
      <line x1="5" y1="5" x2="5" y2="19" />
      <line x1="19" y1="5" x2="19" y2="19" />
      <line x1="7" y1="12" x2="17" y2="12" />
      <polyline points="9 9 6 12 9 15" />
      <polyline points="15 9 18 12 15 15" />
    </g>
    <g v-else>
      <line x1="5" y1="19" x2="19" y2="19" />
      <line x1="5" y1="19" x2="16" y2="7" />
      <path d="M10 19a5 5 0 0 0-1.5-3.5" />
    </g>
  </svg>
</template>

<script setup lang="ts">
import { AssemblyMateType } from '@puppycad/cad-core';

interface MateTypeIconProps {
  /** 标准配合类型。 */
  readonly mateType: AssemblyMateType;
}

defineProps<MateTypeIconProps>();
</script>
